module.exports = __webpack_public_path__ + "ins02.png?94f90914557431a90954e0c149e1c5ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins02.png
// module id = 153
// module chunks = 0